import { render } from "./SectionCustomerManager.vue?vue&type=template&id=40d5251e"
import script from "./SectionCustomerManager.vue?vue&type=script&lang=js"
export * from "./SectionCustomerManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__